module.exports = __webpack_public_path__ + "static/media/14UNEP10.8c4170c8.jpg";